import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { InputProps } from '../input-props';

@Component({
  selector: 'miq-filter-bar-label',
  template: `
    <div *ngIf="!!props.field" class="filterbar-label">
      <ng-container *ngIf="props?.isLabelTranslated; else translateLabel">
        <span *ngIf="props?.isTitleCaseRequired !== false; else uppercaseLabelNoTranslation">{{
          props.label || props.field | titlecase
        }}</span>
        <ng-template #uppercaseLabelNoTranslation>
          <span>{{ props.label || props.field }}</span>
        </ng-template>
      </ng-container>
      <ng-template #translateLabel>
        <span *ngIf="props?.isTitleCaseRequired !== false; else uppercaseLabel">{{
          props.label || props.field | xTranslate | titlecase
        }}</span>
        <ng-template #uppercaseLabel>
          <span>{{ props.label || props.field | xTranslate }}</span>
        </ng-template>
      </ng-template>
      <ng-container *ngIf="!!props.hint">
        <mat-icon
          [svgIcon]="props.hint.svgIcon"
          [matTooltip]="props.hint.textMessage"
          matTooltipClass="report-tooltip"
        ></mat-icon>
      </ng-container>
    </div>
  `,
  styleUrls: ['./filter-bar-label.component.scss'],
  standalone: false,
})
export class FilterBarLabelComponent implements OnInit, OnDestroy {
  @Input() props: InputProps;

  ngOnInit() {
    // required by language
  }
  ngOnDestroy() {
    /* label translation purpose added */
  }
}
